import { render, staticRenderFns } from "./NomenclatoreListComponent.vue?vue&type=template&id=39dccc36"
import script from "./NomenclatoreListComponent.vue?vue&type=script&lang=js"
export * from "./NomenclatoreListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports